<template>
  <fn-section
    constrained="l"
    background-color="sand-light"
    padding-top="xs"
    padding-bottom="xs"
  >
    <fn-panel-image
      image-hide-mobile
      column-size="6"
    >
      <template #image>
        <fn-picture src="@/assets/img/error-img.jpg" />
      </template>

      <template #default>
        <fn-section
          no-padding-x
          padding-top="s"
        >
          <fn-headline type="h2">
            {{ $t('newsletter.unsubscribe.confirmation.headline') }}
          </fn-headline>

          <fn-paragraph>
            <template v-if="email">
              {{ $t('newsletter.unsubscribe.confirmation.text') }}
            </template>
            <template v-else>
              {{ $t('newsletter.unsubscribe.confirmation.textNoEmail') }}
            </template>
          </fn-paragraph>

          <fn-list
            background-color="orange"
            foreground-color="white"
            unstyled
            icons
            colored
          >
            <li v-if="email">
              <fn-icon
                icon="email"
                size="xs"
              />
              <span>
                {{ email }}
              </span>
            </li>
            <li>
              <fn-icon
                icon="warning"
                size="xs"
              />
              <span v-html="$t('newsletter.unsubscribe.confirmation.note')" />
            </li>
          </fn-list>
        </fn-section>
      </template>
    </fn-panel-image>
  </fn-section>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    image: string;
    email: string;
  }>(),
  {
    email: '',
  },
);
</script>
